import { get } from "@/services/axiosUitils";

interface DailySpentHoursParams {
  date?: string; // Format: YYYY-MM-DD
}

interface DailySpentHoursResponse {
  success: {
    code: string;
    message: string;
  };
  date: string;
  total_employees: number;
  employees_with_data: number;
  employees_without_data: number;
  absent_count: number;
  data: Array<{
    employee: {
      id: string;
      name: string | null;
    };
    project: string | null;
    task: string | null;
    /** Parent task id when API returns it (for resolving sub-task labels). */
    task_id?: string | null;
    sub_task?: string | null;
    status?: string | null;
    category: string | null;
    estimatedhours?: string | number | null;
    estimated_hours?: string | number | null;
    /** Cumulative / task worked time from API (e.g. decimal or "H:MM"). */
    worked_hours?: string | number | null;
    workedHours?: string | number | null;
    work_hours?: string | number | null;
    hours: string | null;
    description: string | null;
    date: string | null;
    attendance_hours: string | null;
    difference_hours: string | null;
    is_absent?: boolean;
  }>;
}

class PtsDailySpentHoursService {
  /**
   * Get daily spent hours report
   * Calls: /pts_app/daily-spent-hours/?date=YYYY-MM-DD
   * @param params - Query parameters
   * @param params.date - Date in YYYY-MM-DD format (optional, defaults to today)
   * @returns Daily spent hours report data
   */
  getDailySpentHours = async (
    params?: DailySpentHoursParams
  ): Promise<DailySpentHoursResponse> => {
    return await get<DailySpentHoursResponse>("/pts_app/daily-spent-hours/", {
      params,
    });
  };
}

const instance = new PtsDailySpentHoursService();
export default instance;
